// extracted by mini-css-extract-plugin
export default {"multiListsContainer":"NewListsTab_multiListsContainer__CoRu-"};